










































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import {
  DocuSignTemplateSignHereModel,
  DocuSignTemplateSignHereConfigurationModel,
  DocuSignTemplateSignHereCreateUpdateModel,
  DocuSignTemplateSignHereSearchModel,
  Configuration
} from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import DocuSignUpdateTemplateSignHere from '@/components/configuration/docuSign/DocuSignUpdateTemplateSignHere.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
export default Vue.extend({
  name: 'DocusignAddTemplateSignHere',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  data() {
    return {
      isLoading: false,
      hasError: false,
      errorMessage: '',
      submitIsLoading: false,
      serverValidationMessage: '',
      docuSignTemplateSignHereModel: {} as DocuSignTemplateSignHereModel,
      docuSignTemplateSignHereConfigurationModel: {} as DocuSignTemplateSignHereConfigurationModel
    };
  },
  methods: {
    async getData(this: any, id: number) {
      this.isLoading = true;
      try {
        // tslint:disable-next-line:max-line-length
        this.docuSignTemplateSignHereConfigurationModel = await DocuSignConfigurationService.getTemplateSignHereConfiguration(
          {
            documentTypeId: this.documentTypeId,
            templateSignHereId: this.templateSignHereId
          } as DocuSignTemplateSignHereSearchModel
        );
        this.docuSignTemplateSignHereModel = this.docuSignTemplateSignHereConfigurationModel.templateSignHere;
        this.docuSignTemplateSignHereModel.tabName = this.docuSignTemplateSignHereModel.tabName ?? '';
      } catch (error) {
        this.$log('Error getting template sign here');
      } finally {
        this.isLoading = false;
      }
    },
    async onSubmit(this: any, docuSignTemplateSignHereUpdateModel: DocuSignTemplateSignHereCreateUpdateModel) {
      this.resetFormValidation();
      try {
        this.submitIsLoading = true;
        const result = await DocuSignConfigurationService.createTemplateSignHereAsync(
          docuSignTemplateSignHereUpdateModel
        );

        if (result.hasNotification && !result.showToast) {
          this.serverValidationMessage = result.notification;
          this.submitIsLoading = false;
          return;
        }

        SnotifyConfiguration.showSuccess('Signer Location created successfully.');
        this.setApplicationDirty(false);
        this.navigateToTemplateSignHereManagement();
      } catch (error) {
        this.serverValidationMessage = 'Error creating Signer Location';
      } finally {
        this.submitIsLoading = false;
      }
    },
    navigateToTemplateSignHereManagement(this: any) {
      const param = {} as { [index: string]: any };
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.TemplateSignHere.Management.name,
        params: param
      });
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    }
  },
  mounted(this: any) {
    this.getData();
  },
  components: {
    LoadingSpinner,
    DocuSignUpdateTemplateSignHere
  }
});
